import { observe } from "selector-observer"
import { createApp } from "vue"
import SidebarContainer from "./SidebarContainer.vue"

observe("#track-sidebar", function(el: HTMLElement) {
  const trackId = el.dataset.trackId
  const isAdmin = el.dataset.isAdmin === "true"
  createApp(SidebarContainer, { trackId, isAdmin }).mount(el)
})
